<template>
  <div>
    <label>
      Select Metal Family:
      <select v-model="selectedFamily" @change="selectedGrade = {}">
        <option :value="{}" disabled selected>
          Metal Family
        </option>

        <option v-for="family in alloys" :key="family.name" :value="family">
          {{ family.name }}
        </option>
      </select>
    </label>

    <label v-if="selectedFamily.name">
      Select Grade/Alloy:
      <select v-model="selectedGrade">
        <option :value="{}" disabled selected>
          Grade/Alloy
        </option>

        <option
          v-for="grade in selectedFamily.grades"
          :key="grade.name"
          :value="grade"
        >
          {{ grade.name }}
        </option>
      </select>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      selectedFamily: {},
      selectedGrade: {},
      alloys: [
        {
          name: "Alloy Steel",
          grades: [
            { name: "4137", density: 0.284 },
            { name: "4140", density: 0.284 },
            { name: "4142", density: 0.283 },
            { name: "4150", density: 0.284 },
            { name: "4330", density: 0.283 },
            { name: "4340", density: 0.284 },
            { name: "4715", density: 0.284 },
            { name: "4815", density: 0.284 },
            { name: "6150", density: 0.284 },
            { name: "6304", density: 0.284 },
            { name: "8620", density: 0.284 },
            { name: "8720", density: 0.284 },
            { name: "8740", density: 0.284 },
            { name: "9310", density: 0.284 },
            { name: "9313", density: 0.284 },
            { name: "135M", density: 0.284 },
            { name: "17-22A", density: 0.284 },
            { name: "3%CrMo S106", density: 0.282 },
            { name: "300M", density: 0.284 },
            { name: "4330M", density: 0.283 },
            { name: "4340M", density: 0.284 },
            { name: "AERMET 100", density: 0.285 },
            { name: "AERMET10", density: 0.285 },
            { name: "BG42", density: 0.28 },
            { name: "ETD150", density: 0.284 },
            { name: "MP159", density: 0.301 },
            { name: "15CDV6", density: 0.29 },
            { name: "16NCD13", density: 0.29 },
            { name: "35NC6", density: 0.29 },
            { name: "35NCD16", density: 0.29 },
            { name: "E16NCD13", density: 0.29 },
            { name: "E32CDV13", density: 0.29 },
            { name: "EZ6NCT25", density: 0.29 }
          ]
        },
        {
          name: "Aluminum Alloy",
          grades: [
            { name: "1100", density: 0.098 },
            { name: "1145", density: 0.098 },
            { name: "2014", density: 0.1 },
            { name: "2017", density: 0.101 },
            { name: "2024", density: 0.1 },
            { name: "2219", density: 0.103 },
            { name: "4032", density: 0.097 },
            { name: "5052", density: 0.101 },
            { name: "6061", density: 0.098 },
            { name: "6063", density: 0.098 },
            { name: "7050", density: 0.102 },
            { name: "7075", density: 0.102 },
            { name: "7085", density: 0.103 }
          ]
        },
        {
          name: "Carbon Steel",
          grades: [
            { name: "1018", density: 0.284 },
            { name: "1026", density: 0.284 },
            { name: "1045", density: 0.284 },
            { name: "1117", density: 0.284 },
            { name: "1137", density: 0.284 },
            { name: "1144", density: 0.284 },
            { name: "1213", density: 0.284 },
            { name: "1215", density: 0.284 },
            { name: "11L17", density: 0.284 },
            { name: "12L14", density: 0.284 },
            { name: "CMI", density: 0.284 },
            { name: "Grade 70", density: 0.284 },
            { name: "H-11", density: 0.284 }
          ]
        },
        {
          name: "Cobalt Chrome",
          grades: [
            { name: "1537", density: 0.3 },
            { name: "MP35N", density: 0.305 },
            { name: "Ultimet", density: 0.306 },
            { name: "3%CRMOV", density: 0.282 }
          ]
        },
        {
          name: "Copper Alloy",
          grades: [
            { name: "PB SN BR", density: 0.322 },
            { name: "C729", density: 0.323 },
            { name: "BE-CU", density: 0.298 },
            { name: "C170", density: 0.298 },
            { name: "C110", density: 0.323 },
            { name: "ETP Copper", density: 0.322 },
            { name: "C623", density: 0.276 },
            { name: "C624", density: 0.269 },
            { name: "C954", density: 0.269 }
          ]
        },
        {
          name: "Ductile Iron",
          grades: [{ name: "80-55-06", density: 0.26 }]
        },
        {
          name: "Iron Alloy",
          grades: [{ name: "FE50%", density: 0.293 }]
        },
        {
          name: "Iron Cobalt Vanadium",
          grades: [{ name: "FeCoV", density: 0.293 }]
        },
        {
          name: "Manganese Bronze",
          grades: [
            { name: "C673", density: 0.293 },
            { name: "MN BR", density: 0.3 }
          ]
        },
        {
          name: "Maraging Steel",
          grades: [{ name: "Maraging Stl", density: 0.289 }]
        },
        {
          name: "Molybdenum Alloy",
          grades: [{ name: "TZM", density: 0.367 }]
        },
        {
          name: "Nickel Alloy",
          grades: [
            { name: "Rene 41", density: 0.298 },
            { name: "600", density: 0.306 },
            { name: "625", density: 0.305 },
            { name: "718", density: 0.296 },
            { name: "750", density: 0.3 },
            { name: "Nimonic 80", density: 0.296 }
          ]
        },
        {
          name: "Nickel Chrome Moly",
          grades: [
            { name: "4% Ni-Cr-Mo S82", density: 0.284 },
            { name: "S82A", density: 0.284 },
            { name: "S82D", density: 0.284 }
          ]
        },
        {
          name: "Nickel Iron Alloy",
          grades: [{ name: "Carp49", density: 0.295 }]
        },
        {
          name: "Nickel Iron Molybdenum",
          grades: [{ name: "Carp80", density: 0.316 }]
        },
        {
          name: "Ni-Cr-Mo Steel",
          grades: [{ name: "S156", density: 0.284 }]
        },
        {
          name: "Plastics",
          grades: [{ name: "Polymide", density: 0.042 }]
        },
        {
          name: "Silicon Bronze",
          grades: [{ name: "C655", density: 0.308 }]
        },
        {
          name: "Silicon Iron",
          grades: [{ name: "SIFE", density: 0.275 }]
        },
        {
          name: "Spring Steel",
          grades: [{ name: "music wire", density: 0.284 }]
        },
        {
          name: "Stainless Steel",
          grades: [
            { name: "21-6-9", density: 0.282 },
            { name: "303SE", density: 0.289 },
            { name: "418 Greek Ascoloy", density: 0.284 },
            { name: "440A", density: 0.282 },
            { name: "Nimonic 90", density: 0.296 },
            { name: "Type 108", density: 0.29 },
            { name: "Type 13-8", density: 0.282 },
            { name: "Type 15-5", density: 0.282 },
            { name: "Type 17-4", density: 0.282 },
            { name: "Type 17-4PH", density: 0.282 },
            { name: "Type 17-7", density: 0.282 },
            { name: "Type 301", density: 0.29 },
            { name: "Type 302", density: 0.284 },
            { name: "Type 303", density: 0.289 },
            { name: "Type 303SE", density: 0.289 },
            { name: "Type 304", density: 0.29 },
            { name: "Type 304L", density: 0.29 },
            { name: "Type 310", density: 0.289 },
            { name: "Type 316", density: 0.289 },
            { name: "Type 316L", density: 0.289 },
            { name: "Type 316LVM", density: 0.289 },
            { name: "Type 321", density: 0.289 },
            { name: "Type 347", density: 0.289 },
            { name: "Type 355", density: 0.29 },
            { name: "Type 403", density: 0.282 },
            { name: "Type 410", density: 0.282 },
            { name: "Type 416", density: 0.282 },
            { name: "Type 420", density: 0.282 },
            { name: "Type 430", density: 0.282 },
            { name: "Type 431", density: 0.282 },
            { name: "Type 440", density: 0.282 },
            { name: "Type 440C", density: 0.282 },
            { name: "Type 455", density: 0.282 },
            { name: "Type 465", density: 0.282 },
            { name: "Type A286", density: 0.286 },
            { name: "Type S240", density: 0.289 },
            { name: "XD15NW", density: 0.284 },
            { name: "Z10CNT18-11", density: 0.282 },
            { name: "Z15CN17-03", density: 0.29 },
            { name: "Z6CNT18-10", density: 0.29 },
            { name: "Z7CNU17-04", density: 0.282 },
            { name: "MARVLAX12", density: 0.29 },
            { name: "455", density: 0.282 },
            { name: "465", density: 0.282 },
            { name: "MarVLAX12H", density: 0.29 },
            { name: "Z3CN18", density: 0.29 }
          ]
        },
        {
          name: "Stellite",
          grades: [{ name: "STEL6B", density: 0.303 }]
        },
        {
          name: "Structural Steel",
          grades: [{ name: "St52.3", density: 0.284 }]
        },
        {
          name: "Titanium",
          grades: [
            { name: "100A CP", density: 0.163 },
            { name: "6 Al - 4 V", density: 0.16 },
            { name: "6 Al - 4 V ELI (Medical)", density: 0.16 },
            { name: "6Al - 2SN - 4Zr - 2Mo", density: 0.164 },
            { name: "6Al - 2SN - 4Zr - 6Mo", density: 0.168 },
            { name: "6Al - 6V - 2Sn", density: 0.164 },
            { name: "7AL - 4Mo", density: 0.162 },
            { name: "Grade 1  CP", density: 0.163 },
            { name: "Grade 17", density: 0.163 },
            { name: "Grade 2  CP", density: 0.163 },
            { name: "Grade 2 CP Aerospace", density: 0.163 },
            { name: "Grade 3  CP", density: 0.163 },
            { name: "Grade 3 CP Aerospace", density: 0.163 },
            { name: "Grade 4  CP", density: 0.163 },
            { name: "Grade 4 CP Aerospace", density: 0.163 },
            { name: "Grade 70", density: 0.164 },
            { name: "Ti 10V-2Fe-3Al", density: 0.168 },
            { name: "TI 3Al-2.5V", density: 0.162 },
            { name: "Ti Gr 4 CP 70", density: 0.163 }
          ]
        },
        {
          name: "Tool Steel",
          grades: [
            { name: "A-10", density: 0.277 },
            { name: "A-2", density: 0.284 },
            { name: "D-2", density: 0.278 },
            { name: "D-4", density: 0.278 },
            { name: "M50", density: 0.288 },
            { name: "O1", density: 0.282 }
          ]
        }
      ]
    };
  },
  watch: {
    selectedGrade() {
      this.$emit("input", Number(this.selectedGrade.density || 0));
    }
  }
};
</script>
